import { render, staticRenderFns } from "./AlertRoadside.vue?vue&type=template&id=7cb98fac&"
import script from "./AlertRoadside.vue?vue&type=script&lang=js&"
export * from "./AlertRoadside.vue?vue&type=script&lang=js&"
import style0 from "./AlertRoadside.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports